export const getRecipePortionLabel = (
  recipeQuantity: number | string | null | undefined,
  defaultPortions: number | string | null | undefined,
): string | null => {
  const quantity = Number(recipeQuantity)
  const portions = Number(defaultPortions)

  if (!quantity || !portions || quantity === portions) return null

  return `${quantity} portion${quantity === 1 ? '' : 's'}`
}
